import { Injectable } from '@angular/core';
import { ISectionPresenter } from '../../../models/section-presenter';
import { DeviceSettingsFeatureToggle } from 'src/app/enums/feature-toggle.enum';
import { LocalStorageKey } from 'src/app/enums/local-storage-key.enum';
import { FeatureToggleService } from 'src/app/services/feature-toggle/feature-toggle.service';
import { CommonService } from 'src/app/services/common/common.service';
import { EMachineType } from 'src/app/enums/machine-type.enum';
import { PowerService } from 'src/app/services/power/power.service';

@Injectable({
	providedIn: 'root',
})
export class PowerSettingsSection implements ISectionPresenter {
	constructor(
		private featureToggle: FeatureToggleService,
		private commonService: CommonService,
		private power: PowerService
	) {}

	public async isVisible(): Promise<boolean> {
		const machineType = this.commonService.getLocalStorageValue(LocalStorageKey.MachineType);
		const isFeatureToggleEnabled = this.isFeatureToggleEnabled();
		let isPowerSettingsAvailable = false;

		if (isFeatureToggleEnabled) {
			const flipToBootAvailable = await this.power.getFlipToBootAvailability();
			switch (machineType) {
				case EMachineType.IdeaPad:
					const alwaysOnUSBCapability =
						await this.power.getAlwaysOnUSBStatusIdeaNoteBook();
					isPowerSettingsAvailable =
						isPowerSettingsAvailable || alwaysOnUSBCapability?.available;
					break;
				case EMachineType.ThinkPad:
					const alwaysOnUSB = await this.power.getAlwaysOnUSBCapabilityThinkPad();
					const airplanePowerModeAvailable =
						await this.power.getAirplaneModeCapabilityThinkPad();
					const easyResumeAvailable = await this.power.getEasyResumeCapabilityThinkPad();

					isPowerSettingsAvailable =
						isPowerSettingsAvailable ||
						alwaysOnUSB ||
						airplanePowerModeAvailable ||
						easyResumeAvailable;
					break;
			}

			isPowerSettingsAvailable = isPowerSettingsAvailable || flipToBootAvailable;
		}

		return isPowerSettingsAvailable;
	}

	public isFeatureToggleEnabled(): boolean {
		return this.featureToggle.isDeviceSettingsFeatureAvailable(
			DeviceSettingsFeatureToggle.PowerSettings
		);
	}
}
